/**
 * @generated SignedSource<<6e1efeb8cdedf2857776e2cde0060599>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ClientAccountGroupNameChangeInput = {
  accountGroupId: any;
  clientId: any;
  newName: string;
};
export type AccountGroupAccordion_UpdateClientAccountGroupNameMutation$variables = {
  input: ClientAccountGroupNameChangeInput;
};
export type AccountGroupAccordion_UpdateClientAccountGroupNameMutation$data = {
  readonly UpdateClientAccountGroupName: {
    readonly accountGroup: {
      readonly accounts: ReadonlyArray<{
        readonly financialAccountId: number;
        readonly id: any;
      }>;
      readonly id: string;
      readonly name: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly message: string;
    }> | null;
  };
};
export type AccountGroupAccordion_UpdateClientAccountGroupNameMutation = {
  response: AccountGroupAccordion_UpdateClientAccountGroupNameMutation$data;
  variables: AccountGroupAccordion_UpdateClientAccountGroupNameMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "AccountGroup",
  "kind": "LinkedField",
  "name": "accountGroup",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "accounts",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "financialAccountId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountGroupAccordion_UpdateClientAccountGroupNameMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ClientUserPayload",
        "kind": "LinkedField",
        "name": "UpdateClientAccountGroupName",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccountGroupAccordion_UpdateClientAccountGroupNameMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ClientUserPayload",
        "kind": "LinkedField",
        "name": "UpdateClientAccountGroupName",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "165d663e7ab42c627d247f4e2e06cde3",
    "id": null,
    "metadata": {},
    "name": "AccountGroupAccordion_UpdateClientAccountGroupNameMutation",
    "operationKind": "mutation",
    "text": "mutation AccountGroupAccordion_UpdateClientAccountGroupNameMutation(\n  $input: ClientAccountGroupNameChangeInput!\n) {\n  UpdateClientAccountGroupName(input: $input) {\n    accountGroup {\n      id\n      name\n      accounts {\n        id\n        financialAccountId\n      }\n    }\n    errors {\n      __typename\n      message\n      code\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f51150122e5fabe496fdb6fb22110edd";

export default node;
